import React from "react";
import { Box, Container, Typography, Grid, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";

const values = [
  { title: "Innovación", desc: "Promovemos ideas creativas y tecnológicas que impulsan el progreso constante.", color: "#ff6700" },
  { title: "Responsabilidad", desc: "Cumplimos nuestros compromisos con ética, transparencia y compromiso social.", color: "#ff781f" },
  { title: "Integridad", desc: "Actuamos con honestidad, coherencia y respeto en cada acción.", color: "#e65100" },
  { title: "Excelencia", desc: "Buscamos la mejora continua y resultados de alta calidad en todo lo que hacemos.", color: "#ff6700" },
  { title: "Orientación al Cliente", desc: "Escuchamos, entendemos y ofrecemos soluciones adaptadas a las necesidades de nuestros clientes.", color: "#ff781f" },
];

const MotionCard = motion(Card);

export default function ValuesSection() {
  return (
    <Box sx={{ backgroundColor: "#000", color: "#fff", py: { xs: 6, md: 10 }, overflowX: "hidden" }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} viewport={{ once: true }}>
          <Typography
            variant="h3"
            sx={{ textAlign: "center", fontWeight: 700, letterSpacing: 0.5, color: "#ff6700", mb: { xs: 4, md: 6 }, fontSize: { xs: "1.8rem", sm: "2rem", md: "2.3rem" } }}
          >
            Nuestros Valores
          </Typography>
        </motion.div>

        <Grid
          container
          spacing={{ xs: 3, sm: 4 }}
          justifyContent="center"
          alignItems="stretch"
          sx={{ mx: "auto" }}
        >
          {values.map((val, i) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={i}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <MotionCard
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
                viewport={{ once: true }}
                sx={{
                  backgroundColor: "#121212",
                  color: "#fff",
                  borderRadius: 3,
                  border: { xs: `2px solid ${val.color}`, sm: "2px solid transparent" },
                  boxShadow: { xs: `0 0 24px ${val.color}`, sm: "0 6px 18px rgba(0,0,0,.4)" },
                  transform: { xs: "translateY(-4px)", sm: "none" },
                  transition: "all .25s ease",
                  width: { xs: "92%", sm: "100%" },
                  maxWidth: { xs: 360, sm: 380 },
                  minHeight: { sm: 210, md: 200 },
                  mx: "auto",
                  "&:hover": {
                    borderColor: { sm: val.color },
                    boxShadow: { sm: `0 0 24px ${val.color}` },
                    transform: { sm: "translateY(-6px)" }
                  }
                }}
              >
                <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
                  <Typography
                    variant="h5"
                    sx={{
                      textAlign: "center",
                      fontWeight: 800,
                      color: { xs: "#fff", sm: val.color },
                      mb: { xs: 0, sm: 1.5 },
                      fontSize: { xs: "1.15rem", sm: "1.35rem", md: "1.5rem" }
                    }}
                  >
                    {val.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      display: { xs: "none", sm: "block" },
                      color: "#d8d8d8",
                      textAlign: "center",
                      mt: 1,
                      lineHeight: 1.55,
                      fontSize: { sm: ".98rem", md: "1rem" }
                    }}
                  >
                    {val.desc}
                  </Typography>
                </CardContent>
              </MotionCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
